var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/components/link-footer.tsx";
const _excluded = ["children", "className"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classNames from 'clsx';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { logOut } from 'soapbox/actions/auth';
import { Text } from 'soapbox/components/ui';
import emojify from 'soapbox/features/emoji/emoji';
import { useSoapboxConfig, useOwnAccount, useFeatures } from 'soapbox/hooks';
import sourceCode from 'soapbox/utils/code';

const FooterLink = _ref => {
  let {
    children,
    className
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Link, _extends({
    className: classNames('text-gray-700 dark:text-gray-600 hover:text-gray-800 dark:hover:text-gray-500 hover:underline', className)
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 7
    }
  }), children));
};

const LinkFooter = () => {
  const account = useOwnAccount();
  const features = useFeatures();
  const soapboxConfig = useSoapboxConfig();
  const dispatch = useDispatch();

  const onClickLogOut = e => {
    dispatch(logOut());
    e.preventDefault();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap items-center divide-x-dot text-gray-600",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 7
    }
  }, account && /*#__PURE__*/React.createElement(React.Fragment, null, features.profileDirectory && /*#__PURE__*/React.createElement(FooterLink, {
    to: "/directory",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "navigation_bar.profile_directory",
    defaultMessage: "Profile directory",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 41
    }
  })), /*#__PURE__*/React.createElement(FooterLink, {
    to: "/blocks",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "navigation_bar.blocks",
    defaultMessage: "Blocks",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 36
    }
  })), /*#__PURE__*/React.createElement(FooterLink, {
    to: "/mutes",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "navigation_bar.mutes",
    defaultMessage: "Mutes",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 35
    }
  })), features.filters && /*#__PURE__*/React.createElement(FooterLink, {
    to: "/filters",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "navigation_bar.filters",
    defaultMessage: "Filters",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 39
    }
  })), features.federating && /*#__PURE__*/React.createElement(FooterLink, {
    to: "/domain_blocks",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "navigation_bar.domain_blocks",
    defaultMessage: "Domain blocks",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 45
    }
  })), account.admin && /*#__PURE__*/React.createElement(FooterLink, {
    to: "/soapbox/config",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "navigation_bar.soapbox_config",
    defaultMessage: "Soapbox config",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 46
    }
  })), account.locked && /*#__PURE__*/React.createElement(FooterLink, {
    to: "/follow_requests",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "navigation_bar.follow_requests",
    defaultMessage: "Follow requests",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 47
    }
  })), features.import && /*#__PURE__*/React.createElement(FooterLink, {
    to: "/settings/import",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "navigation_bar.import_data",
    defaultMessage: "Import data",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 47
    }
  })), /*#__PURE__*/React.createElement(FooterLink, {
    to: "/logout",
    onClick: onClickLogOut,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "navigation_bar.logout",
    defaultMessage: "Logout",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 60
    }
  })))), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 7
    }
  }, soapboxConfig.linkFooterMessage ? /*#__PURE__*/React.createElement("span", {
    className: "inline-block align-middle",
    dangerouslySetInnerHTML: {
      __html: emojify(soapboxConfig.linkFooterMessage)
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 11
    }
  }) : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "getting_started.open_source_notice",
    defaultMessage: "{code_name} is open source software. You can contribute or report issues at {code_link} (v{code_version}).",
    values: {
      code_name: sourceCode.displayName,
      code_link: /*#__PURE__*/React.createElement(Text, {
        theme: "subtle",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79,
          columnNumber: 26
        }
      }, /*#__PURE__*/React.createElement("a", {
        className: "underline",
        href: sourceCode.url,
        rel: "noopener",
        target: "_blank",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79,
          columnNumber: 47
        }
      }, sourceCode.repository)),
      code_version: sourceCode.version
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 11
    }
  })));
};

export default LinkFooter;